<label [class.clickable]="clickable">
  <ng-content />
  @if (hasRequiredBadge) {
    <span class="badge-required">*</span>
  }
  <ng-content select="rt-icon-help" />
  <ng-content select="rt-badge" />
  <ng-content select="[label-content-slot]" />
</label>
@if (description) {
  <span class="description">
    {{ description }}
  </span>
}
